const STORAGE_KEY = 'evento';

// The "active session type" (USER / PROFESSIONAL / ADMIN) is kept in
// sessionStorage, which is PER-TAB, not localStorage, which is shared across
// every tab of the origin. Firebase itself uses browserLocalPersistence, so all
// three Firebase apps can be signed in at once (shared IndexedDB) — the only
// thing that has to differ per tab is *which* of those identities this tab is
// acting as. With a single shared localStorage key, logging into admin in one
// tab overwrote the user/professional session in another (every tab subscribes
// to all three Firebase apps in App.js), flipping the other tab's identity and
// then wiping the shared key on the next auth callback. sessionStorage isolates
// each tab, so admin and user/professional can be used side by side.
//
// Trade-off: sessionStorage is cleared when the tab closes, so a brand-new tab
// starts logged out (even though Firebase still has the persisted auth) and the
// user signs in again there. That is the intended cost of per-tab identities.

// One-time cleanup: a stale key left in localStorage by the old shared-storage
// build would otherwise linger unused. Remove it so it can't cause confusion.
try {
  localStorage.removeItem(STORAGE_KEY);
} catch {
  /* ignore storage access errors (e.g. privacy mode) */
}

export const getStoredSession = () => {
  try {
    const rawSession = sessionStorage.getItem(STORAGE_KEY);
    return rawSession ? JSON.parse(rawSession) : null;
  } catch {
    return null;
  }
};

export const isAuthenticated = () => Boolean(getStoredSession()?.type);

export const localStorageData = user => {
  const session = {
    type: user?.type,
    userID: user?.userID ?? null,
  };

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  return session;
};

export const LOGOUT = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export const isCurrentlyLoggedUser = id => getStoredSession()?.userID === id;
